import React from "react";
import {
    Box,
    TableContainer,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    Table,
} from '@material-ui/core';

export default class ComponentToPrint extends React.Component {
    render() {

        const { supplierWiseData, routeWiseData, dataType, selectedSearchValues } = this.props

        const routeWiseColumns = [
            { id: "routeName", label: "Route" },
            { id: "totalNetWeight", label: "Crop Weight (KG)" },
            { id: "gross", label: "Gross" },
            { id: "totalAddition", label: "Addition Pay" },
            { id: "coinBF", label: "Coins" },
            { id: "transport", label: "Transport" },
            { id: "debtsBF", label: "B/F Debts" },
            { id: "fertilizerBF", label: "B/F Fertilizer" },
            { id: "advancePayment", label: "Advance" },
            { id: "teaDeduction", label: "Tea" },
            { id: "fertilizerDeductions", label: "Fertilizer" },
            { id: "festivalAdvance", label: "Festival Advance" },
            { id: "chemicalDeductions", label: "Chemical" },
            { id: "mealDeduction", label: "Meal" },
            { id: "loanPayment", label: "Loan" },
            { id: "stamp", label: "Stamp" },
            { id: "otherDeductions", label: "Other" },
            { id: "bankCharge", label: "Bank Charge" },
            { id: "totalDeductions", label: "Total Deductions" },
            { id: "balance", label: "Balance" },
            { id: "debtsCF", label: "C/F Debts" },
            { id: "fertilizerCF", label: "C/F Fertilizer" },
            { id: "loanBalance", label: "Loan Balance" },
            { id: "cash", label: "Cash" },
            { id: "bank", label: "Bank" },
            { id: "coinCF", label: "C/F Coins" }
        ];

        const supplierWiseColumns = [
            { id: "registrationNumber", label: "Reg. No." },
            { id: "customerName", label: "Supplier Name" },
            { id: "totalNetWeight", label: "Crop Weight (KG)" },
            { id: "gross", label: "Gross" },
            { id: "totalAddition", label: "Addition Pay" },
            { id: "coinBF", label: "Coins" },
            { id: "transport", label: "Transport" },
            { id: "debtsBF", label: "B/F Debts" },
            { id: "fertilizerBF", label: "B/F Fertilizer" },
            { id: "advancePayment", label: "Advance" },
            { id: "teaDeduction", label: "Tea" },
            { id: "fertilizerDeductions", label: "Fertilizer" },
            { id: "festivalAdvance", label: "Festival Advance" },
            { id: "chemicalDeductions", label: "Chemical" },
            { id: "mealDeduction", label: "Meal" },
            { id: "loanPayment", label: "Loan" },
            { id: "stamp", label: "Stamp" },
            { id: "otherDeductions", label: "Other" },
            { id: "bankCharge", label: "Bank Charge" },
            { id: "totalDeductions", label: "Total Deductions" },
            { id: "balance", label: "Balance" },
            { id: "debtsCF", label: "C/F Debts" },
            { id: "fertilizerCF", label: "C/F Fertilizer" },
            { id: "loanBalance", label: "Loan Balance" },
            { id: "cash", label: "Cash" },
            { id: "bank", label: "Bank" },
            { id: "coinCF", label: "C/F Coins" }
        ];


        const collectionTypeMap = new Map();
        (dataType === 'supplierWise' ? supplierWiseData : []).forEach(row => {
            (row.balanceRates || []).forEach(br => {
                const key = br.collectionTypeID !== 0 ? br.collectionTypeID : br.collectionTypeName;
                if (key !== undefined && !collectionTypeMap.has(key)) collectionTypeMap.set(key, { id: key, name: br.collectionTypeName || '' });
            });
            (row.cropDetails || []).forEach(cd => {
                const key = cd.collectionTypeID !== 0 ? cd.collectionTypeID : cd.collectionTypeName;
                if (key !== undefined && !collectionTypeMap.has(key)) collectionTypeMap.set(key, { id: key, name: cd.collectionTypeName || '' });
            });
        });
        const typeColumns = Array.from(collectionTypeMap.values());

        const fixedRightColumns = [
            { id: "supplierCropNet", label: "Total Crop Weight" },
            { id: "gross", label: "Total Gross" },
            { id: "totalAddition", label: "Addition Pay" },
            { id: "coinBF", label: "Coins" },
            { id: "transport", label: "Transport" },
            { id: "debtsBF", label: "B/F Debts" },
            { id: "fertilizerBF", label: "B/F Fertilizer" },
            { id: "advancePayment", label: "Advance" },
            { id: "teaDeduction", label: "Tea" },
            { id: "fertilizerDeductions", label: "Fertilizer" },
            { id: "festivalAdvance", label: "Festival Advance" },
            { id: "chemicalDeductions", label: "Chemical" },
            { id: "mealDeduction", label: "Meal" },
            { id: "loanPayment", label: "Loan" },
            { id: "stamp", label: "Stamp" },
            { id: "otherDeductions", label: "Other" },
            { id: "bankCharge", label: "Bank Charge" },
            { id: "totalDeductions", label: "Total Deductions" },
            { id: "balance", label: "Balance" },
            { id: "debtsCF", label: "C/F Debts" },
            { id: "fertilizerCF", label: "C/F Fertilizer" },
            { id: "loanBalance", label: "Loan Balance" },
            { id: "cash", label: "Cash" },
            { id: "bank", label: "Bank" },
            { id: "coinCF", label: "C/F Coins" }
        ];

        const totals = (dataType === 'supplierWise' ? supplierWiseData : routeWiseData).reduce((acc, row) => {
            fixedRightColumns.forEach(col => {
                acc[col.id] = (acc[col.id] || 0) + parseFloat(row[col.id] || 0);
            });
            if (dataType !== 'supplierWise') {
                acc['totalNetWeight'] = (acc['totalNetWeight'] || 0) + parseFloat(row['totalNetWeight'] || 0);
                acc['gross'] = (acc['gross'] || 0) + parseFloat(row['gross'] || 0);
            }
            return acc;
        }, {});

        const cellStyle = {
            border: '1px solid black',
            padding: '2px',
            fontSize: '8px',
            textAlign: 'center'
        };

        const now = new Date();
        const printedDateTime = now.toLocaleString('en-US', {
            year: 'numeric', month: '2-digit', day: '2-digit',
            hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false
        });

        const headerRowSpan = typeColumns.length > 0 ? 2 : 1;

        return (
            <div>
                <style>{`
                    @page {
                        margin: 10mm;
                        size: A4 portrait;
                    }
                    @media print {
                        body {
                            background-color: white !important;
                            margin: 0 !important;
                        }
                        * {
                            background-color: transparent !important;
                            box-shadow: none !important;
                        }
                    }
                    .print-wrapper {
                        width: 100%;
                        padding: 0;
                        box-sizing: border-box;
                    }
                    .pdf-table {
                        width: 100%;    
                        border-collapse: collapse;
                        table-layout: auto;
                    }
                    .pdf-table th,
                    .pdf-table td {
                        border: 1px solid black;
                        padding: 2px;
                        font-size: 7px;
                        word-break: break-word;
                        white-space: normal;
                    }
                    .pdf-table th { font-weight: bold; }
                    /* Overriding any MUI table container scroll bars during print */
                    .MuiTableContainer-root {
                        overflow: visible !important;
                    }
                `}</style>
                <div style={{ marginTop: '25px' }}></div>
                <div style={{ display: 'flex', justifyContent: 'flex-start', paddingLeft: '10px' }}>
                    <p style={{ fontSize: '10px', margin: '0' }}>
                        <b>Printed Date & Time:</b> {printedDateTime}
                    </p>
                </div>
                <h3><center><u>{dataType === 'supplierWise' ? "Balance Payment Ledger Report" : "Route Wise Balance Payment Summary Report"}</u></center></h3>
                <h4 style={{ margin: 0 }}><center>{"Group: " + selectedSearchValues.groupName}</center></h4>
                <h4 style={{ margin: 0 }}><center>{"Factory: " + selectedSearchValues.factoryName}</center></h4>
                <h4 style={{ margin: 0 }}><center>{dataType === 'supplierWise' ? "Route: " + selectedSearchValues.routeName : "Route: All Routes"}</center></h4>
                <h4 style={{ margin: 0 }}><center>{selectedSearchValues.month + " - " + selectedSearchValues.year}</center></h4>
                <div style={{ marginTop: '10px' }}></div>
                <div>
                    {dataType === 'supplierWise' ? (
                        <div style={{ width: '100%' }}>
                                <table className="pdf-table" aria-label="simple table">
                                    <thead>
                                        <tr>
                                            <th rowSpan={headerRowSpan}>Reg. No.</th>
                                            <th rowSpan={headerRowSpan}>Supplier Name</th>
                                            <th colSpan={typeColumns.length > 0 ? typeColumns.length : 1}>Rate</th>
                                            <th colSpan={typeColumns.length > 0 ? typeColumns.length : 1}>Crop Weight</th>
                                            <th colSpan={typeColumns.length > 0 ? typeColumns.length : 1}>Gross</th>
                                            {fixedRightColumns.map(col => (
                                                <th key={col.id} rowSpan={headerRowSpan}>{col.label}</th>
                                            ))}
                                        </tr>
                                        {typeColumns.length > 0 && (
                                            <tr>
                                                {typeColumns.map(col => <th key={`r_${col.id}`}>{col.name}</th>)}
                                                {typeColumns.map(col => <th key={`c_${col.id}`}>{col.name}</th>)}
                                                {typeColumns.map(col => <th key={`g_${col.id}`}>{col.name}</th>)}
                                            </tr>
                                        )}
                                    </thead>
                                    <tbody>
                                        {supplierWiseData.map((row, index) => (
                                            <tr key={index}>
                                                <td>{row.registrationNumber}</td>
                                                <td style={{textAlign: 'left'}}>{row.customerName}</td>
                                                {typeColumns.length > 0 ? (
                                                    typeColumns.map(col => {
                                                        const brItem = (row.balanceRates || []).find(item => {
                                                            const key = item.collectionTypeID !== 0 ? item.collectionTypeID : item.collectionTypeName;
                                                            return key == col.id;
                                                        });
                                                        const rateVal = brItem !== undefined ? (brItem.rate ?? 0) : 0;
                                                        return <td key={`rt_${col.id}`} align="right">{Number(rateVal).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</td>;
                                                    })
                                                ) : <td align="right">{Number(row.rate ?? 0).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</td>}
                                                
                                                {typeColumns.length > 0 ? (
                                                    typeColumns.map(col => {
                                                        const cdItems = (row.cropDetails || []).filter(item => {
                                                            const key = item.collectionTypeID !== 0 ? item.collectionTypeID : item.collectionTypeName;
                                                            return key == col.id;
                                                        });
                                                        const cropVal = cdItems.reduce((sum, item) => sum + (parseFloat(item.cropWeight) || 0), 0);
                                                        return <td key={`cw_${col.id}`} align="right">{Number(cropVal).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</td>;
                                                    })
                                                ) : <td align="right">{Number(row.supplierCropNet ?? 0).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</td>}

                                                {typeColumns.length > 0 ? (
                                                    typeColumns.map(col => {
                                                        const cdItems = (row.cropDetails || []).filter(item => {
                                                            const key = item.collectionTypeID !== 0 ? item.collectionTypeID : item.collectionTypeName;
                                                            return key == col.id;
                                                        });
                                                        const grossVal = cdItems.reduce((sum, item) => sum + (parseFloat(item.amount) || 0), 0);
                                                        return <td key={`gr_${col.id}`} align="right">{Number(grossVal).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</td>;
                                                    })
                                                ) : <td align="right">{Number(row.gross ?? 0).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</td>}

                                                {fixedRightColumns.map(col => {
                                                    let cellVal = row[col.id] ?? 0;
                                                    if (col.id === 'supplierCropNet') {
                                                        cellVal = (row.cropDetails || []).reduce((sum, c) => sum + (parseFloat(c.cropWeight) || 0), 0);
                                                    } else if (col.id === 'gross') {
                                                        cellVal = (row.cropDetails || []).reduce((sum, c) => sum + (parseFloat(c.amount) || 0), 0);
                                                    }
                                                    return (
                                                        <td key={col.id} align="right">
                                                            {Number(cellVal).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                        </td>
                                                    );
                                                })}
                                            </tr>
                                        ))}
                                        <tr>
                                            <th>Total</th>
                                            <th></th>
                                            {typeColumns.length > 0 ? typeColumns.map(col => <th key={`tr_${col.id}`}></th>) : <th></th>}
                                            {typeColumns.length > 0 ? typeColumns.map(col => {
                                                const colTotal = supplierWiseData.reduce((sum, r) => {
                                                    const cdItem = (r.cropDetails || []).find(item => {
                                                        const key = item.collectionTypeID !== 0 ? item.collectionTypeID : item.collectionTypeName;
                                                        return key == col.id;
                                                    });
                                                    return sum + parseFloat(cdItem !== undefined ? cdItem.cropWeight : 0);
                                                }, 0);
                                                return <th key={`tc_${col.id}`} align="right">{Number(colTotal).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</th>;
                                            }) : <th align="right">{Number(supplierWiseData.reduce((sum, r) => sum + parseFloat(r.supplierCropNet || 0), 0)).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</th>}
                                            {typeColumns.length > 0 ? typeColumns.map(col => {
                                                const colTotal = supplierWiseData.reduce((sum, r) => {
                                                    const cdItem = (r.cropDetails || []).find(item => {
                                                        const key = item.collectionTypeID !== 0 ? item.collectionTypeID : item.collectionTypeName;
                                                        return key == col.id;
                                                    });
                                                    return sum + parseFloat(cdItem !== undefined ? cdItem.amount : 0);
                                                }, 0);
                                                return <th key={`tg_${col.id}`} align="right">{Number(colTotal).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</th>;
                                            }) : <th align="right">{Number(supplierWiseData.reduce((sum, r) => sum + parseFloat(r.gross || 0), 0)).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</th>}
                                            
                                            {fixedRightColumns.map(col => (
                                                <th key={col.id} align="right">
                                                    {Number(totals[col.id] || 0).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                </th>
                                            ))}
                                        </tr>
                                    </tbody>
                                </table>
                        </div>
                    ) : (
                        <Box minWidth={1050} style={{ paddingLeft: '10px', paddingRight: '10px' }}>
                            <TableContainer>
                                <Table size="small" aria-label="simple table">
                                    <TableHead>
                                        <TableRow style={{ border: '1px solid black' }}>
                                            {routeWiseColumns.map((column) => (
                                                <TableCell
                                                    key={column.id}
                                                    style={{ ...cellStyle, fontWeight: "bold", fontSize: "12px" }}
                                                    align="center"
                                                >
                                                    {column.label}
                                                </TableCell>
                                            ))}
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {routeWiseData.map((row, index) => (
                                            <TableRow key={index} style={{ border: '1px solid black' }}>
                                                {routeWiseColumns.map((column) => (
                                                    <TableCell
                                                        key={column.id}
                                                        style={cellStyle}
                                                        align={typeof (row[column.id]) === "number" ? "right" : "left"}
                                                    >
                                                        {typeof (row[column.id]) === 'string' ?
                                                            row[column.id] :
                                                            Number(row[column.id]).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
                                                        }
                                                    </TableCell>
                                                ))}
                                            </TableRow>
                                        ))}
                                        <TableRow>
                                            {routeWiseColumns.map((column) => (
                                                <TableCell
                                                    key={column.id}
                                                    style={{ ...cellStyle, fontWeight: "bold" }}
                                                    align={typeof (totals[column.id]) === "number" ? "right" : "left"}
                                                >
                                                    {column.id === "routeName"
                                                        ? <b>Total</b>
                                                        : <b>{Number(totals[column.id]).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</b>}
                                                </TableCell>
                                            ))}
                                        </TableRow>
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Box>
                    )}
                </div>

                <div>&nbsp;</div>
                <h4><center>***** End of List *****</center></h4>
            </div>
        );
    }
}